import React, { FC, HTMLAttributes } from "react";
import styled, { css } from "styled-components";
import { ProjectActivity } from "interfaces/front/business";
import BottomSlide from "components/front/project/activity/BottomSlide";

type Props = HTMLAttributes<HTMLLIElement> & {
  activity: ProjectActivity;
  selected: boolean;
  onSelect: () => void;
  onSlide?: (event: "start" | "end") => void;
  firstRow?: boolean;
};
const ActivityItem: FC<Props> = ({ activity, firstRow, selected, onSelect, onSlide }) => {
  return (
    <Root $first={firstRow}>
      <HeaderArea onClick={onSelect} $prioritizes={activity.prioritizes}>
        <DateArea>{activity.announce_at}</DateArea>
        {activity.prioritizes && (
          <BadgeArea>
            <Badge>注目</Badge>
          </BadgeArea>
        )}
        <TitleArea>{activity.title}</TitleArea>
      </HeaderArea>
      <BottomSlide<HTMLParagraphElement> in={selected} onSlide={onSlide}>
        {({ container }) => <ContentArea ref={container} dangerouslySetInnerHTML={{ __html: activity.content.replace(/\n/g, "<br />") }} />}
      </BottomSlide>
    </Root>
  );
};
export default ActivityItem;

const Root = styled.li<{ $first?: boolean }>`
  color: white;
  border-bottom: 1px solid #666;

  ${({ $first = false }) =>
    $first &&
    css`
      border-top: 1px solid #666;
    `}
`;

const HeaderArea = styled.div<{ $prioritizes: boolean }>`
  background-color: rgba(255, 255, 255, 0.16);
  cursor: pointer;
  @media screen and (max-width: 960px) {
    padding: 16px 10px;
  }
  @media screen and (min-width: 961px) {
    display: flex;
    align-items: center;
    padding: 20px;
  }
`;

const DateArea = styled.div`
  color: #ccc;
  display: inline-block;
  @media screen and (max-width: 960px) {
    font-size: 0.9em;
    line-height: 0.9;
    margin-bottom: 10px;
  }
  @media screen and (min-width: 961px) {
    flex-shrink: 0;
    margin-right: 20px;
  }
`;

const BadgeArea = styled.div`
  @media screen and (max-width: 960px) {
    margin-bottom: 10px;
  }
  @media screen and (min-width: 961px) {
    margin-right: 10px;
    flex-shrink: 0;
  }
`;
const Badge = styled.span`
  display: inline-block;
  background-color: #e74c3c;
  color: white;
  padding: 4px 8px;
  @media screen and (max-width: 960px) {
    font-size: 0.9em;
    line-height: 0.9;
  }
  @media screen and (min-width: 961px) {
    font-size: 13px;
    line-height: 1;
  }
`;

const TitleArea = styled.div`
  line-break: anywhere;
  line-height: 1.428em;

  @media screen and (max-width: 960px) {
    align-items: flex-start;
  }
  @media screen and (min-width: 961px) {
    align-items: center;
    flex-direction: row;
  }
`;

const ContentArea = styled.div`
  background-color: rgba(128, 128, 128, 0.1);
  line-height: 1.428em;
  @media screen and (max-width: 960px) {
    padding: 10px;
  }
  @media screen and (min-width: 961px) {
    font-size: 16px;
    padding: 20px;
  }

  a {
    color: white;
    text-decoration: underline;
  }

  img {
    width: 100%;
  }
`;
